import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { RoundImage } from './RoundImage';

import { width, isPortrait } from '../../utils/size';

const ImageContainer = styled.div`
    ${props =>
        props.multi
            ? `
          display: flex;
          flex-direction: row;
        `
            : ''};

    > div {
        width: calc(${props => props.size} + 6px);
        border: 3px solid #fff;
        background-color: #fff;
        border-radius: 100%;
        ${props =>
            props.isLocalRepLoading
                ? `
          border-radius: 100%;
          background-image: linear-gradient(to left, #f8f8f7, #f3f3f0 50%, #f8f8f7);
          border: solid 1px #f8f8f7;
        `
                : ''};

        ${props =>
            props.multi
                ? `
            margin-left: -16px;
            &:first-child {
              margin-left: -3px;
            }
          `
                : isPortrait()
                ? `margin: 0 auto;`
                : ''};
    }

    img {
        ${props => (props.isLocalRepLoading ? `display: none;` : '')};
    }
`;

const imageSize = (numImages, isLongTitle) => {
    if (!numImages) return '0px';
    if (isPortrait()) return isLongTitle ? '65px' : '100px';
    let preferredSize = Math.min(150, width() / 2.5) / numImages;
    let max = isLongTitle ? 65 : 110;
    return Math.max(40, Math.min(max, preferredSize)) + 'px';
};

export const MultiImageBlock = props => {
    const size = props.size || imageSize(props.imgSources.length, props.isLongTitle);
    return (
        <ImageContainer
            multi={props.imgSources.length > 1}
            size={size}
            isLocalRepLoading={props.isLocalRepLoading}
        >
            {(props.imgSources || []).map((img, ind) => (
                <RoundImage key={ind} src={img} size={size} />
            ))}
        </ImageContainer>
    );
};

MultiImageBlock.propTypes = {
    imgSources: PropTypes.array,
    isLocalRepLoading: PropTypes.bool,
    size: PropTypes.string,
    isLongTitle: PropTypes.bool
};
